import { render, staticRenderFns } from "./TemplateCreate.vue?vue&type=template&id=f4228b5a&scoped=true"
import script from "./TemplateCreate.vue?vue&type=script&lang=js"
export * from "./TemplateCreate.vue?vue&type=script&lang=js"
import style0 from "./TemplateCreate.vue?vue&type=style&index=0&id=f4228b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4228b5a",
  null
  
)

export default component.exports